<template>
  <el-dialog
    :visible.sync="show"
    :append-to-body="true"
    width="560px"
		:close-on-click-modal="false"
		:show-close="false"
    class="dialog_diy"
  >
    <div class="box">
     <div class="b_img">
			<img :src="require('../../../../assets/icon/pblCourse/huishou.png')">
		 </div>
		 <div class="b_title">
			<span>通关成功</span>
		 </div>
		 <div class="b_content">
			<span>恭喜，你已解锁新关卡，是否进入下一阶段学习</span>
		 </div>
			<div class="b_btn">
				<span class="b_b_cancel" @click="cancel()">取消</span>
				<span class="b_b_submit" @click="submit()">确认</span>
			</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
  
  },
  data() {
    return {
     show:false,
    };
  },
  methods: {
		open(){
			this.show = true;
		},
		close(){
			this.show = false;
		},
		cancel(){
			this.$emit('cancel');
		},
		submit(){
			this.$emit('submit');
		}
  },
};
</script>

<style scoped>
.dialog_diy >>> .el-dialog {
  /* height: 100%; */
  /* margin: 0 auto !important; */
	border-radius: 10px;
}

.dialog_diy >>> .el-dialog__header {
  background: #fff !important;
	display: none;
}

.dialog_diy >>> .el-dialog__body {
  height: calc(100% - 124px);
  box-sizing: border-box;
  padding: 0px;
	border-radius: 12px;
}

.dialog_diy >>> .el-dialog__title {
  color: #000;
}

.dialog_diy >>> .el-dialog__headerbtn {
  top: 19px;
}

.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close {
  color: #000;
}

.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #000;
}

.dialog_diy >>> .el-dialog__body,
.dialog_diy >>> .el-dialog__footer {
  background: #fff;
}

.box{
	width: 560px;
	height: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.box>div{
	margin: 10px 0;
}

.b_img{
	width: 100px;
	height: 100px;
}

.b_img>img{
	width: 100%;
	height: 100%;
}

.b_title{
	font-size: 24px;
	font-weight: bold;
}

.b_content{
	width: 80%;
	color: #00000099;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	font-size: 18px;
}
.b_btn{
	display: flex;
}
.b_btn>span{
	width: 100px;
	height: 50px;
	border-radius: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	font-size: 18px;
	margin: 0 10px;
}

.b_b_cancel{
	background-color: #F3F7FD;
}

.b_b_submit{
	background: linear-gradient(90deg, #3673E8 0%, #AD88FD 100%);
	color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/pblCourse/component/successPhaseDialog.vue